import UnifiedVersion from './App.unified';
import Date20250401Version from './App.2025-04-01';
import { AuthMethodSelector_SelectPageModel, ClientConfiguration, ViewVersion } from '../renditions';

export type AuthMethodSelectorProps = {
  viewVersion: ViewVersion
  requestUrl: string
  clientConfiguration: ClientConfiguration
  model: AuthMethodSelector_SelectPageModel
  allowImmediateRedirect?: boolean
}

export default function App(props: AuthMethodSelectorProps) {
  switch (props.viewVersion) {
    case '2025-04-01':
      return <Date20250401Version {...props} />
    case 'initial':
    case 'unified':
        return <UnifiedVersion {...props} />
    default:
      assertUnreachableViewVersion(props.viewVersion);
  }
}

function assertUnreachableViewVersion(x: never): never {
  throw new Error(`Unandled viewVersion: ${x}`);
}